export default function releaseNotesDirective() {
  return {
    template: require('./release-notes.html'),
    restrict: 'E',
    controller: 'ReleaseNotesController',
    controllerAs: 'releaseNotesVM',
    bindToController: true,
    replace: true,
    scope: {
      releaseNoteItems: '=',
      searchText: '=',
    },
  };
}
